import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchApiData } from '../../../store/slicers/apiSlicer.js';
import Link from 'react-router-dom/Link.js';
import useChangeLanguage from '../../../logic/useChangeLanguage.js';

const NewsSection = () => {
  const dispatch = useDispatch();
  const [actualites, setActualites] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const { getArticleTitle , getArticleBody , _t} = useChangeLanguage();

  const { data, isLoading } = useSelector((state) => ({
    data: state.apiData?.data?.actualites,
    isLoading: state.apiData?.loading?.actualites
  }));

  useEffect(() => {
    getActualites();
  }, []);

  useEffect(() => {
    if (data?.data) {
      setActualites(data.data);
    }
  }, [data]);

  const getActualites = (page = 1) => {
    dispatch(fetchApiData({
      url: 'articles?page=' + page,
      itemKey: 'actualites',
    }));
    setCurrentPage(page);
  };

  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  };

  const truncateText = (text, length = 150) => {
    const stripped = stripHtml(text);
    return stripped.length > length ? stripped.substring(0, length) + '...' : stripped;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
  };

  if (isLoading && actualites.length === 0) {
    return (
      <div>
        <h2 className="section-title"> {_t("last_articles")}</h2>
        <div className="news-grid">
          {[1, 2, 3, 4, 5, 6].map(i => (
            <div key={i} className="news-card-placeholder">
              <div className="placeholder-image"></div>
              <div className="placeholder-content">
                <div className="placeholder-line"></div>
                <div className="placeholder-line"></div>
                <div className="placeholder-line short"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <h2 className="section-title"> {_t("last_articles")}</h2>
      {!isLoading && actualites.length === 0 ? (
        <div className="no-data-placeholder">
          <i className="pi pi-inbox" style={{fontSize: '4rem', color: '#ccc'}}></i>
          <p>Aucune actualité disponible pour le moment</p>
        </div>
      ) : (
        <>
          <div className="news-grid">
            {actualites.map((item) => (
              <div key={item.id} className="news-card">
                <div 
                  className="news-image" 
                  style={item.image_source_url ? {backgroundImage: `url(${item.image_source_url})`} : {}}
                >
                  {!item.image_source_url && (item.image_alt || 'Article ONPR')}
                </div>
                <div className="news-content">
                  <div className="news-date">{formatDate(item.created_at)}</div>
                  <h3 className="news-title">{ getArticleTitle(item)}</h3>
                  <p className="news-excerpt">{truncateText(getArticleBody(item))}</p>
                  <Link 
                    to={`/detail_new/${item.id}`}
                    className="read-more"
                    
                  >
                  
                  {_t("read_more")} →
                  </Link>
                </div>
              </div>
            ))}
          </div>
          {data?.last_page > 1 && (
            <div className="pagination">
              <button 
                onClick={() => getActualites(currentPage - 1)} 
                disabled={currentPage === 1}
                className="pagination-btn"
              >
                <i className="pi pi-angle-left"></i> Précédent
              </button>
              <span className="pagination-info">Page {currentPage} sur {data.last_page}</span>
              <button 
                onClick={() => getActualites(currentPage + 1)} 
                disabled={currentPage === data.last_page}
                className="pagination-btn"
              >
                Suivant <i className="pi pi-angle-right"></i>
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NewsSection;
